interface EventProductSubscribeModal {
  id: string;
}

export const EVENT_OPEN_PRODUCT_SUBSCRIBE_MODAL =
  'open-product-subscribe-modal';
export const EVENT_CLOSE_PRODUCT_SUBSCRIBE_MODAL =
  'close-product-subscribe-modal';

export const utilEventProductSubscribeModal = {
  open: (id: EventProductSubscribeModal['id']) => {
    window.dispatchEvent(
      new CustomEvent<EventProductSubscribeModal>(
        EVENT_OPEN_PRODUCT_SUBSCRIBE_MODAL,
        {
          detail: { id }
        }
      )
    );
  },

  close: () => {
    window.dispatchEvent(new CustomEvent(EVENT_CLOSE_PRODUCT_SUBSCRIBE_MODAL));
  },

  onOpen: (callback: (id: EventProductSubscribeModal['id']) => void) => {
    const handler = (event: CustomEvent<EventProductSubscribeModal>) =>
      callback(event.detail.id);
    window.addEventListener(
      EVENT_OPEN_PRODUCT_SUBSCRIBE_MODAL,
      handler as EventListener
    );

    return () => {
      window.removeEventListener(
        EVENT_OPEN_PRODUCT_SUBSCRIBE_MODAL,
        handler as EventListener
      );
    };
  },

  onClose: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_CLOSE_PRODUCT_SUBSCRIBE_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_CLOSE_PRODUCT_SUBSCRIBE_MODAL, handler);
    };
  }
};
